export default {_name:'text.iconBlock',module:'Field',view:'Element/Text/IconBlock',options:{xs:10,md:12}}